import React, { useEffect } from "react";
import "./BlockingSnackBar.css";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";
import {
  decrementBlockingCountdown,
  hideBlockingSnackbar,
} from "../../redux/slices/blockingSnackbarSlice";

const BlockingSnackBar: React.FC = () => {
  const dispatch = useDispatch();
  const { isBlockingOpen, blockingCountdown } = useSelector(
    (state: RootState) => state.blockingSnackbar
  );

  useEffect(() => {
    if (!isBlockingOpen) return;

    if (blockingCountdown <= 0) {
      handleRedirect();
      return;
    }

    const timer = setTimeout(() => {
      dispatch(decrementBlockingCountdown());
    }, 1000);

    return () => clearTimeout(timer);
  }, [blockingCountdown, isBlockingOpen, dispatch]);

  const handleRedirect = () => {
    localStorage.removeItem("accessToken");
    dispatch(hideBlockingSnackbar());
    window.location.href = "/login";
  };

  if (!isBlockingOpen) return null;

  return (
    <div className="blocking-snackbar-backdrop">
      <div className="blocking-snackbar">
        <span>Session expired. Redirecting in {blockingCountdown}s...</span>
        <button onClick={handleRedirect}>Login</button>
      </div>
    </div>
  );
};

export default BlockingSnackBar;
